import GroupPushVue from '@/views/sm/group-push/group-push.vue';

const basePath = '/sm/group-push';
const role = 'sm'; // 角色身份

export const SM_GROUP_PUSH_INDEX = 'sm-group-push-index';

export default {
  path: `${basePath}*`,
  redirect: `${basePath}/index`,
  component: GroupPushVue,
  meta: { requiresAuth: true },
  children: [
    {
      path: `${basePath}/index`,
      name: SM_GROUP_PUSH_INDEX,
      component: () => import(
        /* webpackChunkName: "groupPush" */
        `@/views/${role}/group-push/index.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    }
  ]
};
